import React from 'react';

const Loader: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-[300px] bg-white">
      <div className="relative w-20 h-20">
        <div className="absolute inset-0 rounded-full border-4 border-teal-500 animate-spin-slow border-t-transparent" />
        <div className="absolute inset-4 rounded-full border-4 border-[#99f6e4] animate-spin-reverse border-b-transparent" />
        <div className="absolute inset-8 rounded-full bg-teal-500 shadow-inner" />
      </div>
    </div>
  );
};

export default Loader;
